export const SIX_MINUTE_WALK_BASE_PATH = "/recording/six-minute-walk";
export const PRE_WALK_RECORDING_DURATION_SECONDS = 60;
export const POST_WALK_RECORDING_DURATION_SECONDS = 90;
export const WALK_DURATION_SECONDS = 6 * 60;
export const WALK_TURN_AROUND_SECONDS = 3 * 60;
export const POST_RECORDING_RESUME_WINDOW_MS = 60 * 1000;
export const MAX_ACCEPTED_ACCURACY_METERS = 60;
export const MAX_ACCEPTED_SPEED_METRES_PER_SECOND = 3;
export const RETURN_TO_START_THRESHOLD_METERS = 25;
export const ROUTE_TRACE_MIN_POINT_DISTANCE_METERS = 2;
export const ROUTE_TRACE_MIN_POINT_INTERVAL_MS = 2000;
export const ROUTE_TRACE_MAX_POINTS = 180;

export const PRE_WALK_PHASE_SCHEDULE = [
  { seconds: 40, key: "cameraPage.phases.normalPre" },
  { seconds: 3, key: "cameraPage.phases.fastInhale" },
  { seconds: 3, key: "cameraPage.phases.fastExhaleBlast" },
  { seconds: 14, key: "cameraPage.phases.resume" },
];

export const POST_WALK_PHASE_SCHEDULE = [
  { seconds: 10, key: "cameraPage.phases.normalPre" },
  { seconds: 3, key: "cameraPage.phases.fastInhale" },
  { seconds: 3, key: "cameraPage.phases.fastExhaleBlast" },
  { seconds: 74, key: "cameraPage.phases.resume" },
];
